import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { ApiServices } from "../services/api.services";
@Injectable()
export class HomeService {
    viewCanals: EventEmitter<any> = new EventEmitter();
    viewLanguage: EventEmitter<any> = new EventEmitter();
    constructor(private apiService: ApiServices) { }
}